import React from 'react';

import Link from 'brandComponents/Link';

import {IBrandsItemProps} from './IBrandsItem';

import styles from './BrandsItem.module.scss';

const BrandsItem = ({url, children}: IBrandsItemProps) => {
	return (
		<li className={styles['brands__item']}>
			<Link to={url} title={children?.toString()} className={styles['brands__link']}>
				{children}
			</Link>
		</li>
	);
};

export default BrandsItem;
